export { default } from './SpotListCTAThumbnail';
